import { bearerAuth } from "../standardAuthPatterns";
import { defineConnector } from "../types";
import logo from "./logo.svg";

export const ardoq = defineConnector({
  identifier: "ardoq",
  name: "Ardoq",
  tagLine: "Enterprise architecture and asset management",
  logo,
  protocol: "http",
  tags: ["it"],
  defaultUrlPattern: ({ apiAddress }) =>
    apiAddress
      ? `${apiAddress.replace(/\./g, "\\.").replace(/\/$/, "")}/.*`
      : "https://app\\.ardoq\\.com/.*",
  auth: (app) => bearerAuth(app.secret.apiToken),
  steps: [
    {
      title: "Create an access token",
      items: [
        {
          kind: "markdown",
          content:
            "Follow the [Ardoq docs](https://help.ardoq.com/en/articles/44177-organization-label-and-access-tokens) to generate an organization access token.",
        },
      ],
    },
    {
      title: "Enter your API details",
      items: [
        {
          kind: "url",
          label: "API address",
          placeholder: "https://app.ardoq.com",
          required: true,
          defaultValue: "https://app.ardoq.com",
          target: { kind: "configuration", field: "apiAddress" },
        },
        {
          kind: "input",
          label: "API token",
          required: true,
          target: { kind: "secrets", field: "apiToken" },
        },
      ],
    },
  ],
  connectionTest: {
    protocol: "http",
    request: ({ apiAddress }) => `${apiAddress}/api/v2/workspaces?limit=1`,
  },
});
